<template>
  <div class="header_base">
    <div class="header">
      <div class="logo_area">
        <a href="/">
          <img class="logo" src="/img/logo_pc.png?g=2024062801" @click="page('/')">
        </a>
      </div>
      <RightMenu
        :currentUser="currentUser"
        @changePage="page"
      ></RightMenu>
    </div>
    <div>
      <div class="topbanner_area" :class="{ 'single-banner': isSingleBanner }" v-if="isTop && bannerList">
        <div class="slick slick-track pc" v-for="(row, key) in bannerList.list" :key="`pc-${key}`">
          <template v-if="Array.isArray(row.file_name)">
            <img v-for="(fileName, index) in row.file_name"
                  :key="`pc-${key}-${index}`"
                  :src="banner || fileName"
                  :class="{ clickable: hasBannerLink(row, index) }"
                  @click="bannerClick(row, index)">
          </template>
          <img v-else
                :src="banner || row.file_name"
                :class="{ clickable: hasBannerLink(row, 0) }"
                @click="bannerClick(row, 0)">
        </div>
        <div class="slick slick-track sp" v-for="(row, key) in bannerList.list" :key="`sp-${key}`">
          <template v-if="Array.isArray(row.sp_file_name)">
            <img v-for="(fileName, index) in row.sp_file_name"
                  :key="`sp-${key}-${index}`"
                  :src="banner || fileName"
                  :class="{ clickable: hasBannerLink(row, index) }"
                  @click="bannerClick(row, index)">
          </template>
          <img v-else
                :src="banner || row.sp_file_name"
                :class="{ clickable: hasBannerLink(row, 0) }"
                @click="bannerClick(row, 0)">
        </div>
      <!-- GXO buttons (PC & SP) -->
        <!-- <div class="banner-button pc" v-if="this.$route.path === '/'">
          <img
            :src="isJP ? '/img/banner/GXO-PC1-JP.png' : '/img/banner/GXO-PC1-EN.png'"
            @click="openZendeskByLanguage('left')"
          />
          <img
            :src="isJP ? '/img/banner/GXO-PC2-JP.png' : '/img/banner/GXO-PC2-EN.png'"
            alt="GXO Right PC"
            @click="openZendeskByLanguage('right')"
          />
        </div>
        <div class="banner-button sp"  v-if="this.$route.path === '/'">
          <img
            :src="isJP ? '/img/banner/GXO-SP1-JP.png' : '/img/banner/GXO-SP1-EN.png'"
            alt="GXO Left SP"
            @click="openZendeskByLanguage('left')"
          />
          <img
            :src="isJP ? '/img/banner/GXO-SP2-JP.png' : '/img/banner/GXO-SP2-EN.png'"
            alt="GXO Right SP"
            @click="openZendeskByLanguage('right')"
          />
        </div> -->
        <!-- <a
          href="https://xeroplace.jp/gtchaplus"
          target="_blank"
          class="banner-button-container button-left"
        >
          <div class="banner-button"></div>
          <span class="button-text button-text-left">{{ t('販売者募集') }}
          </span>
        </a>
        <a
          href="https://gtchax0218.zendesk.com/hc/ja/sections/4679247601822-%E3%81%94%E5%88%A9%E7%94%A8%E3%82%AC%E3%82%A4%E3%83%89"
          target="_blank"
          class="banner-button-container button-right"
        >
          <div class="banner-button"></div>
          <span class="button-text button-text-right">{{ t('遊び方') }}
          </span>
        </a> -->
      </div>
      <!-- <div class="slick slick-track sp topbanner_area_sp" v-if="isTop && bannerList">
        <img v-for="(row, key) in bannerList.list" :key="key"  :src="banner || row.sp_file_name" @click="bannerClick(row)">
        <img v-for="(row, key) in bannerList.list" :key="key"  :src="banner || row.sp_file_name2" @click="bannerClick(row)">
        <img v-for="(row, key) in bannerList.list" :key="key"  :src="banner || row.sp_file_name3" @click="bannerClick(row)"> -->
        <!-- <a
          href="https://xeroplace.jp/gtchaplus"
          target="_blank"
          class="banner-button-container button-left"
        >
          <div class="banner-button" ></div>
          <span class="button-text button-text-left">{{ t('販売者募集') }}
          </span>
        </a>
        <a
          href="https://gtchax0218.zendesk.com/hc/ja/sections/4679247601822-%E3%81%94%E5%88%A9%E7%94%A8%E3%82%AC%E3%82%A4%E3%83%89"
          target="_blank"
          class="banner-button-container button-right"
        >
          <div class="banner-button" ></div>
          <span class="button-text button-text-right">{{ t('遊び方') }}
          </span>
        </a> -->
      <!-- </div> -->
    </div>
    <div v-if="safeUserDetail" class="menu-overlay" :class="{ active: showMyPage }" @click="toggleMenu(!showMyPage)"></div>
    <div class="menu" :class="{ active: showMyPage }">
      <div class="close-button" @click="toggleMenu(!showMyPage)">×</div>
      <h2>
        <div class="user_id_area">
          <div>{{ t('会員ID') }} </div>
          <div class="user_id gray_frame">{{ safeUserDetail.id }}</div>
        </div>
      </h2>
      <ul>
        <li class="color_frame">
          <div class="rank_area">
            <div class="left">
              <div class="left_title">
                <img src="/img/menu/MemberRank.png" class="MemberRank_img">
                <h3>{{ t('会員ランク') }} </h3>
              </div>
              <div v-if="currentUser.rank !== 6" class="next_rank">{{ t('次のランクまで') }} {{ safeUserDetail.remaining_point | comma }}Coin</div>
              <GachaBarGraph
                v-if="currentUser.rank !== 6"
                :maxValue="safeUserDetail.rank_max_price"
                :currentValue="safeUserDetail.rank_current_price"
              />
              <div v-if="safeUserDetail.is_rank_maintained" class="next_rank_area">
                <button
                  @click="openRankPopup()"
                  class="next_rank_button">
                  {{ t('ランク維持') }}
                </button>
              </div>
            </div>
            <div class="right gray_frame rank_img_area">
              <img :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon">
              <span class="rank_name" :class="{'foreign': !isJP}">
                {{ safeUserDetail.rank_name }}
              </span>
            </div>
          </div>
          <div class="rank_notice">
            <div class="notice">{{ t('※ランクに応じた各種特典が受けられます') }} </div>
            <MypageButton
              class="buy-button"
              :text="t('詳細へ')"
              @handleSquareBtnClick="gotoZendesk"
            />
          </div>
        </li>
        <li class="color_frame">
          <div class="rank_area">
            <div class="left friend_area">
              <div class="left_title">
                <img src="/img/menu/friend.png" class="friend_img">
                <h3>{{ t('友達紹介') }} </h3>
              </div>
              <div>
                <div class="next_rank">
                  <span v-if="isJP">{{ t('あと') }}</span>
                  {{ t('%d 人紹介可能').replace('%d', safeUserDetail.remain_count) }}</div>
                <GachaBarGraph
                  :maxValue="safeUserDetail.referral_count"
                  :currentValue="safeUserDetail.remain_count"
                />
                <div class="referral_detail_button_area">
                  <MypageButton
                    class="buy-button"
                    :text="t('詳細へ')"
                    @handleSquareBtnClick="gotoReferralZendesk"
                  />
                </div>
              </div>
            </div>
            <div class="right gray_frame referral_area referral_code_expanded" v-if="safeUserDetail.referral_code">
              <div>{{ t('紹介コード') }}</div>
              <div class="referral_code">{{ safeUserDetail.referral_code }}</div>
              <MypageButton
                class="buy-button"
                :text="t('コピー')"
                @handleSquareBtnClick="copyReferralCode(safeUserDetail.referral_code)"
              />
            </div>
            <div class="right gray_frame referral_area sms" v-else>
              <MypageButton
                class="sms-button"
                :text="t('SMS認証')"
                @handleSquareBtnClick="smsPopup"
              />
            </div>
          </div>
        </li>
        <li class="color_frame">
          <div class="coupon_area">
            <div class="left_title">
              <img src="/img/menu/coupon.png" class="coupon_img">
              <h3>{{ t('クーポン') }}</h3>
            </div>
            <div class="sub_title">{{ t('お知らせなどで配布') }}</div>
          </div>
          <div class="coupon_area coupon_code">
            <TextBox
              class="text-box"
              inputType="text"
              :value="couponCode"
              :placeholder="t('クーポンコードを入力してください')"
              @handleTextInput="inputCoupon"
            />
            <MypageButton
              class="buy-button"
              :text="t('適用')"
              @handleSquareBtnClick="clickCouponCode"
            />
          </div>
          <div class="alert_message" v-html="couponCodeErrorHtml"></div>
        </li>
        <li class="menu-text menu-text-first" @click="page('/notice-list', true)">
          <img src="/img/menu/news2.png" />
          {{ t('お知らせ') }}
        </li>
        <li class="menu-text" @click="page('/undecided-detail', true)">
          <img src="/img/menu/history.png" />
          {{ t('履歴') }}
        </li>
        <li class="menu-text" @click="page('/watch-videos', true)">
          <img src="/img/menu/watch_video.png" />
          {{ t('動画を見てコインを獲得') }}
        </li>
        <!-- Xmarket機能廃止
        <li class="menu-text" @click="page('/market-mylist-undecided', true)">
          <img src="/img/menu/Xmarket.png" />
          {{ t('Xmarket 出品リスト') }}
        </li> -->
        <!-- Xmarket機能廃止により出金申請をコメントアウト
        <li class="menu-text" @click="page('/request-payment', true)">
          <img src="https://img.icons8.com/?size=100&id=ij9Fvjj8ABOS&format=png&color=000000" />
          {{ t('出金申請') }}
        </li> -->
        <li class="menu-text" @click="page('/faq', true)">
          <img src="/img/menu/FAQ.png" />
          {{ t('FAQ') }}
        </li>
        <li class="menu-text" @click="page('/change-member', true)">
          <img src="/img/menu/mypage.png" />
          {{ t('登録情報') }}
        </li>
        <li class="menu-text" v-if="!isSocial" @click="page('/change-password', true)">
          <img src="/img/menu/Password.png" />
          {{ t('パスワード変更') }}
        </li>
      </ul>
    </div>
    <LoginPopup></LoginPopup>
    <CountryPopup
      v-show="showCuntoryPopup"
      @handleClose="showCuntoryPopup = false"
    ></CountryPopup>
    <SMSPopup
      v-if="showSMSPopup"
      :tel="tel"
      @success="smsSuccess"
      @closePopup="showSMSPopup = false">
    </SMSPopup>
    <RankPopup
      v-if="showRankPopup"
      :currentUserDetail="currentUserDetail"
      :currentUser="currentUser"
      @closePopup="showRankPopup = false"
    />
  </div>
</template>

<script>
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import RightMenu from '@/components/molecules/Header/RightMenu.vue';
import GachaBarGraph from '@/components/atoms/GachaBarGraph.vue';
import MypageButton from '@/components/atoms/MypageButton.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import LoginPopup from '@/components/organisms/LoginPopup.vue';
import CountryPopup from '@/components/organisms/CountryPopup.vue';
import SMSPopup from '@/components/molecules/SMSPopup.vue';
import RankPopup from '@/components/molecules/RankPopup.vue';

export default {
  name: 'CommonHeader',
  mixins: [t],

  props: {
    availablePoint: {
      type: String,
      default: '0',
    },
    currentUser: {
      type: Object,
      default: () => {},
    },
    isTop: {
      type: Boolean,
      default: false,
    },
    banner: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    showMenu: false,
    showMenuArea: false,
    tel: null,
    copyResult: '',
    couponCode: '',
    couponCodeError: '',
    showCuntoryPopup: false,
    showSMSPopup: false,
    showRankPopup: false,
    isSocial: false,
    isShowAlertSuccess: false,
  }),

  created() {
    if (this.isTop) {
      this.$store.dispatch('banner/getBannerList', {
        path: this.$route.path,
        isJP: this.isJP,
      });
    }
    this.$store.dispatch('user/setCurrentUserDetail');
    this.$store.dispatch('user/setCurrentUser');
    // ログインしている場合、国と言語が設定されていない場合は設定する
    if (this.currentUser && this.currentUser.is_login === '1' && !this.currentUser.is_country) {
      this.showCuntoryPopup = true;
    }
  },

  mounted() {
    if (this.isTop) {
      window.$(window).off('resize');
      window.$(window).on('resize', () => {
        this.checkBreakPoint();
      });
    }
  },

  components: {
    RightMenu,
    GachaBarGraph,
    MypageButton,
    TextBox,
    LoginPopup,
    CountryPopup,
    SMSPopup,
    RankPopup,
  },

  computed: {
    ...mapGetters({
      bannerMode: 'banner/bannerMode',
      bannerList: 'banner/bannerList',
      showMyPage: 'user/showMyPage',
      currentUserDetail: 'user/currentUserDetail',
      resultCouponUseError: 'coupon/resultCouponUseError',
      currentLanguage: 'user/currentLanguage',
    }),
    safeUserDetail() {
      return this.currentUserDetail || {};
    },
    couponCodeErrorHtml() {
      return (this.couponCodeError || '').replace(/\\n|\n/g, '<br>');
    },
    isJP() {
      return this.currentLanguage === 'ja';
    },
    isSingleBanner() {
      if (this.bannerList && this.bannerList.list && Array.isArray(this.bannerList.list[0].file_name)) {
        return this.bannerList.list[0].file_name.length === 1;
      }
      return true;
    },
  },

  watch: {
    bannerList() {
      setTimeout(() => {
        this.checkBreakPoint();
      }, 100);
    },
    resultCouponUseError(val) {
      this.couponCodeError = val;
      console.log('resultCouponUseError', val);
      if (!val) {
        window.location.href = '/buy-point';
      }
    },
    safeUserDetail(newVal) {
      if (newVal) {
        this.tel = newVal.tel ?? '';
        this.isSocial = newVal.is_social_login;
      }
    },
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
    commaDecimal(value) {
      return separateDecimalNumber(value);
    },
  },

  methods: {
    openRankPopup() {
      this.showRankPopup = true;
    },
    openZendeskByLanguage(side = 'left') {
      // 左ボタン用URL
      const leftUrlMap = {
        ja: 'https://gtchax0218.zendesk.com/hc/ja/articles/4679247601310-%E4%BC%9A%E5%93%A1%E3%83%A9%E3%83%B3%E3%82%AF%E5%88%B6%E5%BA%A6%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6',
        en: 'https://gtchax0218.zendesk.com/hc/en-us/articles/4679247601310-About-the-membership-rank-system',
        de: 'https://gtchax0218.zendesk.com/hc/de/articles/4679247601310-%C3%9Cber-das-System-der-Mitgliedschaftsr%C3%A4nge',
        fr: 'https://gtchax0218.zendesk.com/hc/fr/articles/4679247601310-%C3%80-propos-du-syst%C3%A8me-de-classement-des-membres',
        it: 'https://gtchax0218.zendesk.com/hc/it/articles/4679247601310-Informazioni-sul-sistema-di-classificazione-dei-membri',
        ko: 'https://gtchax0218.zendesk.com/hc/ko/articles/4679247601310-%ED%9A%8C%EC%9B%90-%EB%93%B1%EA%B8%89-%EC%A0%9C%EB%8F%84-%EC%95%88%EB%82%B4',
        zh: 'https://gtchax0218.zendesk.com/hc/zh-cn/articles/4679247601310-%E5%85%B3%E4%BA%8E%E4%BC%9A%E5%91%98%E7%AD%89%E7%BA%A7%E5%88%B6%E5%BA%A6',
        'zh-TW': 'https://gtchax0218.zendesk.com/hc/zh-tw/articles/4679247601310-%E9%97%9C%E6%96%BC%E6%9C%83%E5%93%A1%E7%AD%89%E7%B4%9A%E5%88%B6%E5%BA%A6',
      };
      // 右ボタン用URL
      const rightUrlMap = {
        ja: 'https://gtchax0218.zendesk.com/hc/ja/articles/4704590708510-%E8%B2%B4%E7%A4%BE%E3%81%AE%E5%95%86%E6%9D%90%E3%82%92GTCHAX-Online%E3%81%A7%E8%B2%A9%E5%A3%B2',
        en: 'https://gtchax0218.zendesk.com/hc/en-us/articles/4966036589982-Get-coins-by-posting-on-Instagram-and-TikTok',
        de: 'https://gtchax0218.zendesk.com/hc/de/articles/4966036589982-Erhalten-Sie-M%C3%BCnzen-indem-Sie-auf-Instagram-und-TikTok-posten',
        fr: 'https://gtchax0218.zendesk.com/hc/fr/articles/4966036589982-Obtenez-des-pi%C3%A8ces-en-publiant-sur-Instagram-et-TikTok',
        it: 'https://gtchax0218.zendesk.com/hc/it/articles/4966036589982-Ottieni-monete-pubblicando-su-Instagram-e-TikTok',
        ko: 'https://gtchax0218.zendesk.com/hc/ko/articles/4966036589982-%EC%9D%B8%EC%8A%A4%ED%83%80%EA%B7%B8%EB%9E%A8%EA%B3%BC-%ED%8B%B1%ED%86%A1%EC%97%90-%EA%B2%8C%EC%8B%9C%ED%95%98%EC%97%AC-%EC%BD%94%EC%9D%B8%EC%9D%84-%ED%9A%8D%EB%93%9D%ED%95%98%EC%84%B8%EC%9A%94',
        zh: 'https://gtchax0218.zendesk.com/hc/zh-cn/articles/4966036589982-%E5%9C%A8Instagram%E5%92%8CTikTok%E5%8F%91%E5%B8%96%E8%8E%B7%E5%8F%96%E9%87%91%E5%B8%81',
        'zh-TW': 'https://gtchax0218.zendesk.com/hc/zh-tw/articles/4966036589982-%E5%9C%A8Instagram%E5%92%8CTikTok%E7%99%BC%E6%96%87%E7%8D%B2%E5%8F%96%E4%BB%A3%E5%B9%A3',
      };

      const userLang = (this.currentUser && this.currentUser.language) || null;
      let lang = userLang || (this.isJP ? 'ja' : 'en');
      const map = side === 'right' ? rightUrlMap : leftUrlMap;
      // 特例: 右ボタンで未ログインかつ日本以外の場合は英語へフォールバック
      if (side === 'right' && (!this.currentUser || this.currentUser.is_login === '0') && !this.isJP) {
        lang = 'en';
      }
      const target = map[lang] || map.en;
      window.open(target, '_blank');
    },
    smsPopup() {
      if (!this.tel) {
        // alert(this.t('電話番号を入力してください'));
        this.page('/change-member#tel');
        return;
      }
      if (window.confirm(this.t('SMSコードを送信しますか？'))) {
        this.showSMSPopup = true;
      }
    },
    smsSuccess() {
      this.showSMSPopup = false;
      this.$store.dispatch('user/setCurrentUserDetail');
      this.isShowSMSAlertSuccess = true;
    },
    handleShopNameClick() {
      this.$emit('handleShopNameClick');
    },
    handlePointBoxClick() {
      this.$emit('handlePointBoxClick');
    },
    toggleMenu(mode) {
      // this.showMenu = mode;
      // if (mode) {
      //   this.showMenuArea = mode;
      // } else {
      //   setTimeout(() => {
      //     this.showMenuArea = mode;
      //   }, 500);
      // }
      this.$store.dispatch('user/setShowMyPage', mode);
      if (mode) {
        document.body.classList.add('menu-open');
      } else {
        document.body.classList.remove('menu-open');
      }
    },
    checkBreakPoint() {
      window.$('.slick.slick-initialized').slick('unslick');
      // 画像が1枚の場合はslickを初期化しない（通常表示）
      if (this.isSingleBanner) {
        return true;
      }
      if (window.$(window).width() <= 768) {
        window.$('.slick').slick({
          autoplay: true,
          autoplaySpeed: 2500,
          speed: 800,
          dots: false,
          arrows: true,
          centerMode: true,
          centerPadding: '10%',
          variableWidth: true,
        });
      } else {
        window.$('.slick').slick({
          autoplay: true,
          autoplaySpeed: 2500,
          speed: 800,
          dots: false,
          arrows: true,
          variableWidth: true,
          centerMode: true,
          centerPadding: '5%',
        });
        window.$('.slick').slick('slickGoTo', 0, false);
      }
      return true;
    },
    page(url) {
      this.toggleMenu(false);
      this.$router.push(url);
    },
    logout() {
      this.$store.dispatch('user/logOutUser');
    },
    toiawase() {
      window.open('https://www.iranoan.com/contacts');
    },
    bannerClick(row, index = 0) {
      // 言語別・画像別URLに対応
      const lang = (this.currentUser && this.currentUser.language) || (this.isJP ? 'ja' : 'en');
      const { urls } = row;
      if (urls && typeof urls === 'object') {
        const targetList = urls[lang] || urls.ja || urls.en;
        const targetUrl = Array.isArray(targetList) ? (targetList[index] || targetList[0]) : null;
        if (targetUrl) {
          window.open(targetUrl, '_blank');
          return;
        }
      }
      // 既存の単一URLがあればフォールバック
      if (row.url) {
        window.open(row.url, '_blank');
      }
    },
    hasBannerLink(row, index = 0) {
      const lang = (this.currentUser && this.currentUser.language) || (this.isJP ? 'ja' : 'en');
      const { urls } = row || {};
      if (urls && typeof urls === 'object') {
        const targetList = urls[lang] || urls.ja || urls.en;
        if (Array.isArray(targetList)) {
          return Boolean(targetList[index] || targetList[0]);
        }
      }
      return Boolean(row && row.url);
    },
    copyReferralCode(referralCode) {
      window.navigator.clipboard.writeText(referralCode)
        .then(() => {
          alert('Referral Code copied');
        });
    },
    inputCoupon(value) {
      this.couponCode = value;
    },
    clickCouponCode() {
      console.log('clickCouponCode', this.couponCode);
      this.$store.dispatch('coupon/useCoupon', { couponCode: this.couponCode });
    },
    gotoZendesk() {
      // 各言語のZendeskリンクURLを定義
      const zendeskUrls = {
        'ja': 'https://gtchax0218.zendesk.com/hc/ja/articles/4679247601310-%E4%BC%9A%E5%93%A1%E3%83%A9%E3%83%B3%E3%82%AF%E5%88%B6%E5%BA%A6%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6',
        'en': 'https://gtchax0218.zendesk.com/hc/en-us/articles/4679247601310-About-the-membership-rank-system',
        'it': 'https://gtchax0218.zendesk.com/hc/it/articles/4679247601310-Informazioni-sul-sistema-di-classificazione-dei-membri',
        'de': 'https://gtchax0218.zendesk.com/hc/de/articles/4679247601310-%C3%9Cber-das-System-der-Mitgliedschaftsr%C3%A4nge',
        'es': 'https://gtchax0218.zendesk.com/hc/en-us/articles/4679247601310-About-the-membership-rank-system',
        'fr': 'https://gtchax0218.zendesk.com/hc/fr/articles/4679247601310-%C3%80-propos-du-syst%C3%A8me-de-classement-des-membres',
        'ko': 'https://gtchax0218.zendesk.com/hc/ko/articles/4679247601310-%ED%9A%8C%EC%9B%90-%EB%93%B1%EA%B8%89-%EC%A0%9C%EB%8F%84-%EC%95%88%EB%82%B4',
        'zh': 'https://gtchax0218.zendesk.com/hc/zh-cn/articles/4679247601310-%E5%85%B3%E4%BA%8E%E4%BC%9A%E5%91%98%E7%AD%89%E7%BA%A7%E5%88%B6%E5%BA%A6',
        'zh-TW': 'https://gtchax0218.zendesk.com/hc/zh-tw/articles/4679247601310-%E9%97%9C%E6%96%BC%E6%9C%83%E5%93%A1%E7%AD%89%E7%B4%9A%E5%88%B6%E5%BA%A6',
      };
      const langMode = this.currentUser && this.currentUser.language ? this.currentUser.language : 'ja';
      const targetUrl = zendeskUrls[langMode] || zendeskUrls.ja;
      window.open(targetUrl, '_blank');
    },
    gotoReferralZendesk() {
      const langMode = this.currentUser && this.currentUser.language ? this.currentUser.language : 'ja';
      const targetUrl = langMode === 'ja'
        ? 'https://gtchax0218.zendesk.com/hc/ja/articles/4704693600414-%E5%8F%8B%E9%81%94%E7%B4%B9%E4%BB%8B%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6'
        : 'https://gtchax0218.zendesk.com/hc/en-us/articles/4704693600414-About-refer-a-Friend';
      window.open(targetUrl, '_blank');
    },
    // gotoXmarket() {
    //   // window.open('https://xeroplace.jp/xmarketcominsoon/', '_blank');
    //   window.location.href = 'https://xeroplace.jp/xmarketcominsoon/';
    // },
  },

};
</script>

<style lang="scss" scoped>
.header_base {
  margin-top: 80px;
}
.header {
  margin: 0 -10px;
  position: fixed;
  top: 0;
  background-color: $white;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 10;
  .left_button_area {
    display: flex;
    align-items: flex-start;
    img {
      width: 56px;
      margin-left: 10px;
    }
  }
  .logo_area {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 67px;
    margin-left: 40px;
    @media screen and  (max-width: $tabletWidth) {
      height: 66px;
      margin-left: 10px;
    }
    .logo{
      padding-top: 8px;
    }
  }
  .login_area {
    display: flex;
    justify-content: flex-end;
    width: 120px;
    .login {
      display: flex;
      justify-content: center;
      align-items: center;
      .login_box {
        background-color: $white;
        padding: 0 20px;
        border-radius: 10px;
        a {
          color: $mainColor!important;
        }
      }
      .point_icon {
        width: 36px;
        z-index: 1;
      }
      .point_block {
        background-color: #fff;
        height: 26px;
        margin-left: -6px;
        z-index: 0;
        width: 90px;
        text-align: right;
        display: block;
        padding-right: 9px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        cursor: pointer;
      }
    }
    .coin {
      margin-left: 10px;
    }
  }
}
.left_title{
  display: flex;
  align-items: center;
  img{
    width: 30px;
    height: auto;
    padding-right: 5px;
  }
  h3 {
    font-size: 18px;
    white-space: normal; // ← 折り返し許可
    word-break: break-word; // ← 長い単語も改行
    line-height: 1.2;
  }
}
.menu_area {
  display: flex;
  position: fixed;
  flex-direction: column;
  color: #fff;
  z-index: 10;
  width: 160px;
  padding: 0;
  top: 90px;
  .menu {
    display: none;
  }
  .logout_icon {
    width: 28px;
    margin-top: 0px;
    margin-left: 10px;
  }
}
.logo {
  cursor: pointer;
  width: 196px;
}
.movie_area {
  text-align: center;
  video {
    max-width: 800px;
    width: 100%;
  }
}
.slick-track {
  position: relative;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin: 0!important; // exact slide width control
    max-width: none;
    width: auto; // use intrinsic or explicit below
    vertical-align: bottom;
  }
  .banner-button-container {
    text-decoration: none;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px 0;
    border-radius: 20px;
    box-shadow: 3px 2px 14px rgba(0, 0, 0, 2.5);
    width: 20%;
    &.button-left {
      bottom: 2%;
      left: 10%;
      transform: translateY(-50%);
      @media screen and (min-width: 1350px) {
        bottom: 7%;
      }
    }
    &.button-right {
      bottom: 2%;
      right: 10%;
      transform: translateY(-50%);
      @media screen and (min-width: 1350px) {
        bottom: 7%;
      }
    }
    .button-text {
      color: white;
      text-align: center;
      pointer-events: none; // クリックを無効化
      z-index: 1;
      display: flex; // **文字と矢印を横並びにする**
      align-items: center; // **中央揃え**
      gap: 8px; // **文字と矢印の間隔を調整**
      line-height: 1.1;
      .arrow {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.8em; // **テキストサイズに合わせる**
        color: #045292;
        background-color: rgba(255, 255, 255, 1); // **丸の背景色**
        border-radius: 50%; // **丸くする**
        width: 1.2em;
        height: 1.2em;
        min-width: 1.2em; // **SP時も崩れないように**
        min-height: 1.2em;
        flex-shrink: 0; // **縮小を防ぐ**
      }
    }
    .banner-button {
      position: absolute;
      height: auto;
      cursor: pointer;
      background: linear-gradient(to bottom, #98daff, #055291, #055291, #055291); // 上が明るいグラデ
      border: 1px solid white;
      box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.6); // 内側の光沢感
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
  @media screen and  (max-width: $tabletWidth) {
    margin-bottom: 0;
    .banner-button-container {
      width: 25% !important;
      &.button-left {
        transform: translateY(-10%);
      }
      &.button-right {
        transform: translateY(-10%);
      }
    }
  }
  @media screen and  (max-width: 550px) {
    margin-bottom: 0;
    .banner-button-container {
      width: 30% !important;

      &.button-left {
        left: 3%;
        transform: translateY(-25%);
      }
      &.button-right {
        right: 3%;
        transform: translateY(-25%);
      }
      .button-text {
        font-weight: bold;
        font-size: 12px;
      }
    }
  }
}

.menu-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  z-index: 1000;
}
.menu {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 350px;
  background: white;
  transform: translateX(105%);
  transition: transform 0.3s ease;
  z-index: 1001;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
  color: #353e59;
  h2 {
    padding: 10px 25px;
    // border-bottom: 5px solid #b5bac6;
    font-size: 18px;
    display: flex;
    justify-content: center;
    .user_id_area{
      white-space: nowrap;
      position: relative;
      display: inline-block;
      padding: 10px 20px;
      border-radius: 8px;
      width: 75%;
      display: flex;
      color: $gray2;
      .user_id {
        text-align: center;
        width: 60%;
        margin-left: 5px;
      }
    }
  }
  .gray_frame {
    // background-color: #efefef;
    border-radius: 8px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  }
  // 初期化
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    font-weight: bold;
    li.color_frame {
      // background-image:
      //   linear-gradient(white, white),
      //   // linear-gradient(to right, #4ea8de, #0d1f40);
      //   linear-gradient(to right, yellow, orange, red);
      background-clip: padding-box, border-box;
      background-origin: border-box;
      border-radius: 8px;
      border: 2px solid transparent;
      margin: 5px 5px 10px 5px;
      padding: 5px 10px;
      color: $gray2;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    }
    .rank_area {
      display: flex;
      .left {
        width: 55%;
        text-align: center;
        .next_rank {
          font-size: 14px;
          margin: 5px 0;
        }
      }
      .right {
        width: 45%;
        margin-left: 10px;
      }
      .rank_img_area {
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 20px;
        .rank_icon {
          width: 50px;
        }
        .rank_name{
          white-space: normal;
          word-break: break-word;
          line-height: 1.2;
          &.foreign{
            font-size: 17px;
          }
        }
      }
      .next_rank_button {
        background:
          linear-gradient(white, white) padding-box, // 背景色
          linear-gradient(135deg, #ffd700, #ff8c00) border-box; // 枠色
        border: 2px solid transparent; // 枠線透明にしてグラデ背景を見せる
        margin-top: 5px;
        border-radius: 30px;
        color: #e67300;
        font-weight: bold;
        padding: 3px 12px;
        font-size: 13px;
        box-shadow: 0 2px 6px rgba(255, 165, 0, 0.3);
        cursor: pointer;
      }
    }
      .referral_area {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        padding: 5px 0;
        .referral_code {
          font-size: 16px;
          margin: 5px 0;
          color: #000;
        }
        .buy-button {
          width: 80px;
          font-size: 8px;
          padding: 8px 5px;
        }
        .sms-button{
          width: 135px;
          font-size: 13px;
          padding: 8px 5px;
        }
      }
    .friend_area {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .referral_detail_button_area {
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }
    .referral_code_expanded {
      min-height: 100px;
      padding: 15px 10px;
    }
    .rank_notice {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      .notice {
        font-size: 9px;
        color: red;
      }
    }
    .referral_notice {
      margin-top: 10px;
      font-size: 10px;
      .referral_notice_title {
        font-size: 12px;
        text-align: center;
      }
      .referral_notice_body {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
      }
      .referral_notice_info {
              // background-image:
        // linear-gradient(white, white),
        // linear-gradient(to right, #4ea8de, #0d1f40);
        width: 45%;
        background-clip: padding-box, border-box;
        background-origin: border-box;
        border-radius: 8px;
        border: 2px solid transparent;
        padding: 5px;
      }
      .arrow {
        position: relative;
        margin: 0px;
      }
      .arrow::after,
      .arrow::before {
        content: "";
        display: block;
        width: 2px;
        height: 8px;
        background-color: #000;
        position: absolute;
        // right: 12px;
        transform-origin: center;
      }
      .arrow::before {
        transform: rotate(45deg);
        top: 50%;
        margin-top: 0px;
      }
      .arrow::after {
        transform: rotate(-45deg);
        top: 50%;
        margin-top: -5px;
      }
    }
    .buy-button {
      width: 120px;
      font-size: 12px;
    }
    .coupon_area {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .sub_title {
        font-size: 10px;
        width: 40%;
        text-align: center;
      }
      .buy-button {
        margin-left: 10px
      }
    }
    .coupon_code {
      margin-top: 10px;
    }
    .alert_message {
      color: red;
      line-height: 16px;
      margin-bottom: 10px;
      white-space: pre-wrap;
      font-size: 12px;
    }
    .coupon_notice {
      font-size: 7px;
      margin-top: 5px;
      color: red;
    }
    .menu-text {
      display: flex;
      align-items: center;
      cursor: pointer;
      border-bottom: solid 1px $gray2;
      margin: 0 10px;
      img{
        width: 23px;
        margin-right: 5px;
      }
    }
    li {
      padding: 5px 0;
      color: $gray2;
    }
    .menu-text-first {
      border-top: solid 1px $gray2;
    }
  }
}
.menu.active {
  transform: translateX(0);
  overflow-y: auto;
}
.menu-overlay.active {
  display: block;
}
.close-button {
  position: absolute;
  top: -13px;
  right: 10px;
  font-size: 60px;
  cursor: pointer;
}

@media screen and  (max-width: $tabletWidth) {
  .header_base {
    margin-top: 67px;
  }
  .header {
    padding: 0;
    margin-bottom: 20px;
    .left_button_area {
      align-items: center;
      img {
        width: 40px;
      }
    }
    .logo {
      width: 120px;
    }
    .login_area {
      width: 100px;
      flex-direction: column;
      .login {
        .login_box {
          padding: 5px 10px;
          font-weight: bold;
        }
        .point_icon {
          width: 28px;
        }
        .point_block {
          height: 20px;
          font-size: 14px;
          width: 70px;
          padding-right: 8px;
        }
      }
      .coin {
        margin: 5px 0 0 0;
      }
    }
  }
  .menu_area {
    position: fixed;
    flex-direction: column;
    justify-content: flex-start;
    width: auto;
    min-width: 200px;
    padding: 20px 0 0 0;
    height: calc(100vh - 73px);
    top: 72px;
    div {
      width: 100%;
      margin: 5px 0;
      text-align: center;
      padding-bottom: 4px;
      border-bottom: solid 1px $white;
      &:hover {
        text-decoration: auto;
      }
    }
    .menu {
      display: block;
      text-align: left;
      font-weight: bold;
    }
    .logout_icon {
      width: 28px;
      margin-top: 4px;
      margin-left: 10px;
    }
  }
}
.pc {
  display: flex;
  @media screen and  (max-width: $tabletWidth) {
    display: none;
  }
}
.sp {
  display: none;
  @media screen and  (max-width: $tabletWidth) {
    display: block;
  }
}
@media screen and (max-width: $mobileWidth) {
  .header_base{
    .menu{
      .user_id_area{
        font-size: 15px;
      }
      .color_frame{
        padding: 10px 10px;
        .left{
          h3{
            font-size: 18px;
          }
        }
        .buy-button {
          width: 90px;
        }
        .referral_notice {
          .referral_notice_info {
            padding: 5px;
          }
        }
        .arrow {
          margin: 0px -5px;
        }
      }
      &.active{
        width: fit-content;
      }
    }
  }
}

.topbanner_area{
  // max-width: 1600px;
  margin: 0px -10px;
  // padding-bottom: 10px;
  .slick-track{
    img{
      padding: 0 10px;
    }
    img.clickable{
      cursor: pointer;
    }
  }
  .slick-track.pc {
    img {
      width: 720px;
    }
  }
  .slick-track.sp {
    img {
      width: 360px;
    }
  }
  &.single-banner {
    .slick-track.pc {
      img {
        margin: 0 2px 0 2px !important;
        max-width: 1600px;
        width: 100%;
        vertical-align: bottom;
      }
    }
    .slick-track.sp {
      img {
        margin: 0 2px 0 2px !important;
        max-width: 1600px;
        width: 100%;
        vertical-align: bottom;
      }
    }
  }
  .banner-button{
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      cursor: pointer;
      width: 45%;
      height: auto;
      margin: 10px 5px;
      border-radius: 8px;
      pointer-events: auto; // クリック可能に
    }
  }
  .banner-button.pc {
    display: flex;
    margin-bottom: -15px;
  }
  .banner-button.sp {
    display: none;
    margin-bottom: -15px;
  }
}

@media screen and  (max-width: $tabletWidth) {
  .topbanner_area{
    .banner-button.pc { display: none; }
    .banner-button.sp { display: flex; }
  }
}

@media screen and (max-width: $mobileWidth) {
  .topbanner_area{
    // padding-bottom: 5px;
    .slick-track{
      img{
        padding: 0px 5px;
      }
    }
  }
}

</style>
